import Vue from "vue";
import Router from "vue-router";
import Starter from "./pages/StarterPage.vue";
import chiaraStarter from "./pages/chiaraStarterPage.vue";
import panziStarter from "./pages/panziStarterPage.vue";
import StarterNavbar from "./layout/StarterNavbar.vue";
import chiaraStarterNavbar from "./layout/chiaraStarterNavbar.vue";
import panziStarterNavbar from "./layout/panziStarterNavbar.vue";

import StarterFooter from "./layout/StarterFooter.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      components: {
        default: Starter,
        header: StarterNavbar,
        footer: StarterFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/panzi2023",
      name: "panziLanding",
      components: {
        default: panziStarter,
        header: panziStarterNavbar,
        footer: StarterFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/chiara2021",
      name: "chiaraLanding",
      components: {
        default: chiaraStarter,
        header: chiaraStarterNavbar,
        footer: StarterFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
